<template>
    <b-container>
        <div class="d-block m-auto text-center pb-4">
            <img width="250px" src="../../assets/img/login2.svg" class="img-fluid">
            <h1 class="text-center mt-4 mb-2">Account</h1>
        </div>
        <b-form>
            <b-form-group>
                <router-link :to="{name: 'register'}" class="btn btn-block btn-secondary btn-lg">Register</router-link>
            </b-form-group>

            <b-form-group>
                <b-btn v-b-modal.login-modal size="lg" variant="primary" block>Login to your account</b-btn>
            </b-form-group>

            <b-form-group>
                <b-btn @click="goToCheckout" size="lg" variant="outline-primary" block>Continue as guest</b-btn>
            </b-form-group>
        </b-form>

        <login-modal></login-modal>
    </b-container>
</template>

<script>
    import LoginModal from "./loginModal";
    export default {
        name: "LoginBridge",
        components: {LoginModal},
        data(){
            return {
                isLoginModalOpen: false,
            }
        },

        methods:{
            goToCheckout(){
                this.$router.push({name: 'checkoutGuest'});
            },
        }

    }
</script>

<style scoped>

</style>